import { FC } from "react";
import { useTranslation } from "react-i18next";

import { MuiButton } from "@ryde/controls";
import { GenericUploadStepEnum } from "@ryde/shared";

import { FormFooterStyled } from "../drawer";

interface IGenericUploadFooterProps {
  currentStep: GenericUploadStepEnum;
  onUploadClick: () => void;
  onProcessClick: () => void;
  onCancelClick: () => void;
  isLoading: boolean;
  isSaveDisabled: boolean;
}

export const GenericUploadFooter: FC<IGenericUploadFooterProps> = ({
  currentStep,
  onUploadClick,
  onProcessClick,
  onCancelClick,
  isLoading = false,
  isSaveDisabled,
}) => {
  const { t } = useTranslation();

  const getSaveLabel = (): string => {
    switch (currentStep) {
      case GenericUploadStepEnum.Upload:
        return t("general.upload");
      case GenericUploadStepEnum.Preview:
        return t("general.process");
      case GenericUploadStepEnum.Process:
        return t("general.CLOSE");
      default:
        return t("general.SAVE");
    }
  };

  const handleSaveClick = (): void => {
    switch (currentStep) {
      case GenericUploadStepEnum.Upload:
        onUploadClick();
        break;
      case GenericUploadStepEnum.Preview:
        onProcessClick();
        break;
      case GenericUploadStepEnum.Process:
        onCancelClick();
        break;
      default:
        break;
    }
  };

  const saveLabel = getSaveLabel();

  return (
    <FormFooterStyled>
      <MuiButton
        e2eData="cancel_button_generic_upload_footer"
        muiVariant="outlined"
        color="secondary"
        onClick={onCancelClick}
        loading={isLoading}
      >
        {t("general.CANCEL")}
      </MuiButton>
      <MuiButton
        e2eData={`save_button_generic_upload_footer_${saveLabel}`}
        loading={isLoading}
        muiStyle={isSaveDisabled ? "error" : "primary"}
        disabled={isSaveDisabled}
        onClick={handleSaveClick}
      >
        {saveLabel}
      </MuiButton>
    </FormFooterStyled>
  );
};
